/*
    Created By: Sai Prasad
    Created Date: 26/08/2022
    Jira Ticket: JUN-3152
    Description: upload csv file and convert to an array.
*/

import React from "react";
import { useDropzone } from 'react-dropzone';
import { parse } from "papaparse";
import Button from "../Button";

const CSVUpload = ({
  onFetchData,
  buttonName
}) => {
  const {
    getRootProps,
    getInputProps,
    open
  } = useDropzone({
    noClick: true,
    accept: ".csv",
    onDrop: acceptedFiles => {
      Array.from(acceptedFiles)
        .forEach(async (file) => {
          const text = await file.text();
          const parseData = parse(text, { header: true });
          let result = parseData.data;
          onFetchData(result)
        });
    }
  })
  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <Button
        color="teal"
        label={buttonName}
        onClick={open}
        size="small"
      />
    </div>
  );
}
export default CSVUpload;